import React from "react";
import OperationalResource from "../components/OperationalResource";
export default function Orders() {
  return <OperationalResource title="Orders" resource="orders" />;
}
